import React from "react";
import '../../assets/css/pagination.css';
const CustomPagination = ({ totalPages, currentPage, onPageChange }) => {
    const getPageNumbers = () => {
        const totalNumbers = 5;
        const half = Math.floor(totalNumbers / 2);

        let start = Math.max(currentPage - half, 1);
        let end = Math.min(start + totalNumbers - 1, totalPages);

        if (end - start < totalNumbers - 1) {
            start = Math.max(end - totalNumbers + 1, 1);
        }

        const pages = [];

        if (start > 1) {
            pages.push(1);
            if (start > 2) pages.push("...");
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        if (end < totalPages) {
            if (end < totalPages - 1) pages.push("...");
            pages.push(totalPages);
        }

        return pages;
    };

    const handleClick = (page) => {
        if (page !== "..." && page !== currentPage) {
            onPageChange(page);
        }
    };

    return (
        <div className="custom-pagination">
            <button onClick={() => handleClick(1)} disabled={currentPage === 1}>
                {"«"}
            </button>
            <button onClick={() => handleClick(currentPage - 1)} disabled={currentPage === 1}>
                {"‹"}
            </button>

            {getPageNumbers().map((page, idx) =>
                page === "..." ? (
                    <span key={idx} className="ellipsis">...</span>
                ) : (
                    <button
                        key={idx}
                        onClick={() => handleClick(page)}
                        className={currentPage === page ? "active" : ""}
                    >
                        {page}
                    </button>
                )
            )}

            <button onClick={() => handleClick(currentPage + 1)} disabled={currentPage === totalPages}>
                {"›"}
            </button>
            <button onClick={() => handleClick(totalPages)} disabled={currentPage === totalPages}>
                {"»"}
            </button>
        </div>
    );
};

export default CustomPagination;
